// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.beta-thankyou_bannerImage__cjGk2 {
  object-fit: contain !important;
}

.beta-thankyou_footer__umUxY {
  margin-top: 2rem;
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Popups/BetaSignupSuccessPopup/beta-thankyou.module.scss"],"names":[],"mappings":"AAEA;EACE,8BAAA;AADF;;AAIA;EACE,gBAAA;EACA,gBAAA;AADF","sourcesContent":["@import '../../../../assets/sass/functions';\n\n.bannerImage {\n  object-fit: contain !important;\n}\n\n.footer {\n  margin-top: toRem(32);\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannerImage": `beta-thankyou_bannerImage__cjGk2`,
	"footer": `beta-thankyou_footer__umUxY`
};
export default ___CSS_LOADER_EXPORT___;
